import {
  OpportunitySearchResults,
  OpportunityResultStateEnums,
} from "@skv/core";

import { CustomError } from "@skv/core";

export interface State {
  loading: boolean;
  error: false | null | CustomError;
  data: { [searchQuery: string]: OpportunitySearchResults };
  state: OpportunityResultStateEnums;
}

export type ActionTypes =
  | {
      type: "RESULT:FETCH:START";
    }
  | {
      type: "RESULT:FETCH:END" | "RESULT:FETCH:END:CACHE";
      payload: {
        searchQuery: string;
        data: OpportunitySearchResults;
      };
    }
  | {
      type: "RESULT:FETCH:ERROR";
      payload: {
        error: CustomError;
      };
    }
  | {
      type: "RESULT:ERROR:RESET";
    };

export const reducer = (
  state: State = {
    loading: false,
    error: false,
    data: {},
    state: OpportunityResultStateEnums.IDLE,
  },
  action: ActionTypes
): State => {
  switch (action.type) {
    case "RESULT:FETCH:START":
      return {
        ...state,
        loading: true,
        error: false,
        state: OpportunityResultStateEnums.FETCHING_DATA,
      };
    case "RESULT:FETCH:END":
    case "RESULT:FETCH:END:CACHE":
      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...state.data,
          [action.payload.searchQuery]: action.payload.data,
        },
        state: OpportunityResultStateEnums.IDLE,
      };
    case "RESULT:FETCH:ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        state: OpportunityResultStateEnums.FETCH_ERROR,
      };
    case "RESULT:ERROR:RESET":
      return {
        ...state,
        loading: false,
        error: false,
        state: OpportunityResultStateEnums.IDLE,
      };
    default:
      return state;
  }
};
